/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'console': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M14 0c1.306 0 2.418.835 2.83 2H19a1 1 0 010 2h-2.171a3.001 3.001 0 01-5.658 0H1a1 1 0 110-2h10.17A3.001 3.001 0 0114 0zM6 7c1.306 0 2.418.835 2.83 2H19a1 1 0 010 2H8.829a3.001 3.001 0 01-5.658 0H1a1 1 0 010-2h2.17A3.001 3.001 0 016 7zm5 7c1.306 0 2.418.835 2.83 2H19a1 1 0 010 2h-5.171a3.001 3.001 0 01-5.658 0H1a1 1 0 010-2h7.17A3.001 3.001 0 0111 14z" _fill="#213F6B"/>'
  }
})
